<!-- Button trigger modal -->
<div style="text-align: center; margin-top: 10px;">
    <button *ngIf="contractData && role == 'admin'" [disabled]="contractData.paid" type="button" class="btn btn-success" data-toggle="modal" aria-label="Left Align" data-target="#paidContractModal">
        <span *ngIf="!contractData.paid">
            Marcar contrato pagado
        </span>
        <span *ngIf="contractData.paid">
            Contrato pagado
        </span>
        
    </button>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="paidContractModal" tabindex="-1" role="dialog" aria-labelledby="paidContractModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="paidContractModalLabel">Marcar contrato pago</h5>
                <button type="button" class="close modal-close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="contractData">
                <p>Está seleccionando marcar el contrato #<strong>{{ contractData.id }}</strong> como pagado.</p>
                <p>Para confirmar esto, seleccione "marcar pago".</p>
            </div>
            <div *ngIf="errorMsg" class="alert alert-danger" role="alert">
                Error intente luego...
            </div>
            <div class="modal-footer">
            
                <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                <button type="button" (click)="paidContract()" class="btn btn-success">Marcar Pago</button>
            </div>
       
        </div>
    </div>
    </div>